import axios from 'axios';
import { PaginatedRoles } from './types';

export const fetchRoles = async (): Promise<PaginatedRoles> => {
  return (await axios.get(`/v1/user/role`)).data;
};
